import type { AirCancelQuoteResponse } from "@b2bportal/air-cancel-api";
import { CallState, type ExternalResource } from "@b2bportal/core-types";
import {
  handleAsyncThunk,
  type ThunkErrorType,
} from "@b2bportal/core-utilities";
import { createSlice } from "@reduxjs/toolkit";

import { fetchCancelQuote } from "./thunks";

export type CancelQuoteFetchExternalResource = ExternalResource<
  AirCancelQuoteResponse,
  ThunkErrorType<string>
>;

export interface CfarCancelQuoteState {
  cancelQuoteFetchState: CancelQuoteFetchExternalResource;
}

const initialState: Readonly<CfarCancelQuoteState> = Object.freeze({
  cancelQuoteFetchState: {
    state: CallState.NotCalled,
  },
} as CfarCancelQuoteState);

export const cancelQuoteSlice = createSlice({
  name: "flightsCfarCancelQuote",
  initialState: { ...initialState },
  reducers: {
    resetCancelQuoteState: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    handleAsyncThunk(builder, fetchCancelQuote, (state, resource) => {
      state.cancelQuoteFetchState = resource;
    });
  },
});

export const cancelQuoteAllActions = {
  ...cancelQuoteSlice.actions,
  fetchCancelQuote,
};
